import { z } from 'zod'

import {
  resolveDataClass,
  serializeDataItems,
  unknownEntityError,
} from '../shared/entity-serializer'
import { getHostRuntime } from '@/Atomic/Widgets/AiChatBot/core/engine/host-runtime'
import { defineTool } from '@/Atomic/Widgets/AiChatBot/core/engine/runtime/tool-system'

export const getEntityTool = defineTool({
  name: 'get_entity',
  description:
    'Fetch all fields of a single CRM entity by its ID and type. Use this to look up any record when you have an ID.',
  inputSchema: () =>
    z.object({
      dataClass: z
        .string()
        .describe(
          'Entity type, e.g. Company, Person, Ticket, Opportunity, Order, Quote, Activity, Lead, Timerecord',
        ),
      id: z.string().describe('The _id of the record to fetch'),
    }),

  async run(args, ctx) {
    const { dataClass, id } = args
    if (!resolveDataClass(dataClass)) {
      return unknownEntityError(dataClass)
    }

    const item = await getHostRuntime().data.get(dataClass, id)
    if (!item) {
      return { error: `${dataClass} with id ${id} not found` }
    }

    const [serialized] = await serializeDataItems([item], dataClass, ctx)
    return serialized
  },
})
